import { DefectPrimaryKeyId, PrimaryKeyId, ProjectPrimaryKeyId } from "./brands.model";

/**
 * Visual Modes for Contractor Page
 */
export enum IContractorViewMod {
    active,
    archived,
    showAll,
}

/**
 * Status types for contractors
 */
export enum IContractorStatus {
    active,
    archived,
}

/**
 * Contractor
 * Default model for Options > Contractor
 */
export type IContractor = {
    readonly cloudId: PrimaryKeyId | null | undefined;
    readonly company: string;
    readonly name: string;
    readonly email: string;
    readonly phone: string;
    readonly discipline: string;
    status: IContractorStatus | number;
    readonly isAssigned: boolean;
    readonly lastModified: number;
    /** For testing whether to delete or not */
    readonly lastMapChanged: number;
}

// /**
//  * Modified Contractor for displaying against project
//  * Default model for Project > Selected Assignments
//  */
// export type IProjectContractor = {
//     /** Project Map Id */
//     readonly projectMapId: ProjectPrimaryKeyId | null;
//     /** Contractor Cloud Id */
//     readonly contractorCloudId: PrimaryKeyId;
//     readonly company: string;
//     readonly name: string;
//     defaultAssignment: boolean;
// }

/**
 * Modified IProjectContractor for Assigning to Project
 * Default view for:
 * - Project > Select list of available contractors
 * - Defects > Select list of project contractors
 */
export type IProjectContractorListItem = {
    /** Project Map Id */
    readonly projectMapId: ProjectPrimaryKeyId | null;
    /** Contractor Cloud Id */
    readonly contractorCloudId: PrimaryKeyId;
    readonly company: string;
    readonly name: string;
    readonly email: string;
    readonly groupLabel: string;
    defaultAssignment: boolean;
    selected: boolean;
    display: boolean;
    status: IContractorStatus | number;
    /** -1 indicates not assigned to project contractor */
    readonly projectId: ProjectPrimaryKeyId | -1;
}

/**
 * Selection of Contractors on Defect Pages
 */
export type IDefectContractorAssignment = {
    readonly defectMapId: number | null;
    readonly defectId: DefectPrimaryKeyId | null;
    /** Map Id */
    readonly cloudId: number;
    /** Contractor Id */
    readonly contractorCloudId: PrimaryKeyId;
    readonly company: string;
    readonly name: string;
}